import { Fragment } from 'react';

import { FeaturesNavList, FeaturesList } from './components';
import { FEATURE_ITEMS } from './constants';

const Features = () => {
  const featureItems = [];

  const handleSectionRef = ref => featureItems.push(ref);

  return (
    <Fragment>
      <section className="section section_features_1">
        <div className="wrapper section__wrapper">
          <div className="row">
            <div className="col col-6 col-tablet-12 section_features_1-content">
              <h1 className="title title_size_xl title_white _mb-20 _mt-152 _mt-tablet-0 _mt-quad-153">
                <span className="title__break">Siteplus</span> Features
              </h1>
              <p className="text text_size_xl text_white section__text">
                <span className="text__break">
                  All you need to build your own
                </span>{' '}
                website and more...
              </p>
            </div>
            {/*
                            <div className="col col-6">
                                <div className="section__bg-wrap _mt-453 _mt-quad-573">
                                    <Icon
                                        icon="star"
                                        className="section__icon"
                                    />
                                    <h4 className="title section__sub-title title_white">
                                        Background Video
                                    </h4>
                                    <p className="text text_white section__sub-text">
                                        Bring your website to life!
                                    </p>
                                </div>
                            </div> */}
          </div>
        </div>
      </section>
      <FeaturesNavList nodesList={featureItems} />
      {FEATURE_ITEMS.map((item, key) => (
        <FeaturesList {...item} itemRef={handleSectionRef} id={key} key={key} />
      ))}
    </Fragment>
  );
};

export default Features;
